import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import { GEditor } from './index';
import { Helmet } from 'react-helmet';
import { getCookie } from '../home/app_util';

export class EditSnippet extends Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProject({ projectId, version });
    actions.loadInstalledPlugins({ projectId, version });
    actions.loadProjectAssets({ projectId, version });
    actions.loadExternalApis({ projectId, version });
  }

  showGEditor = () => {
    const { editor, match, common, actions } = this.props;
    const { versions } = common || {};
    const { project, assets, plugins, showBuilderCanvasLoader } = editor || {};
    if (project && match && match.params) {
      const { projectId, templateId, version } = match.params;
      const token = getCookie('token') || '';
      return (
        <GEditor
          projectId={projectId}
          version={version}
          actions={actions}
          uri={`v${version}/projects/${projectId}/snippet-templates/${templateId}/content`}
          project={project}
          versions={versions}
          pageId={templateId}
          assets={assets}
          plugins={plugins}
          editor={editor}
          token={token}
          showBuilderCanvasLoader={showBuilderCanvasLoader}
        />
      );
    }
    return <div>Loader</div>;
  };

  render() {
    const { editor, match } = this.props;
    const {
      loadCollectionsPending,
      loadExternalApisPending,
      loadInstalledPluginsPending,
      loadEventsPending,
    } = editor || '';
    if (
      loadCollectionsPending ||
      loadExternalApisPending ||
      loadEventsPending ||
      loadInstalledPluginsPending
    ) {
      return <p>Loading...</p>;
    }

    const { project, snippets } = editor;
    let selectedSnippet = null;
    if (project) {
      const { projectId, templateId } = match.params;
      if (templateId && snippets && snippets.length) {
        selectedSnippet = snippets.find(
          (snippet) => snippet.uuid === templateId && snippet.projectId === projectId,
        );
      }
    }
    return (
      <Fragment>
        <Helmet>
          <title>
            Snippet: {selectedSnippet ? `${selectedSnippet.name} |` : ''} DrapCode | Build Awesome
            Web Applications
          </title>
        </Helmet>
        {this.showGEditor()}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSnippet);
